import { ClaimedCandidateAdvanceSearchRequestType, ClaimedCandidateGlobalRequestType } from '../../types/claimed';
import { axiosInstance } from './index';

export const claimedCandidateExternalService = {
    async getClaimedCandiateList(params: ClaimedCandidateGlobalRequestType) {
        const { data } = await axiosInstance.get('Candidate/GetUserCandidateLeadPaginatedListExternal', {
            params,
        });
        return data as any;
    },

    async getUnClaimedCandiateEmail(candidateId: string) {
        const { data } = await axiosInstance.get(`Candidate/UnclaimedCandidate/${candidateId}`);
        return data as any;
    },

    async getMarketPlaceUnClaimedCandiateEmail(candidateId: string) {
        const { data } = await axiosInstance.get(`MarketPlace/MarketPlaceCandidate/${candidateId}`);
        return data as any;
    },

    async getClaimedCandidateAdvanceSearchList(formdata: ClaimedCandidateAdvanceSearchRequestType) {
        const { data } = await axiosInstance.post(`Candidate/SearchUserCandidateLeadWithAndExternal`, formdata);
        return data as any;
    },
};
